import { Box } from '@mui/material';
import React from 'react';
import { FootNoteProps } from '../../models/TopLevelTemplateComponentProps';
import FootnoteRenderer from '../FootnoteRenderer';
import PropertyCard from '../PropertyCard';
import PropertyCardGroup from '../PropertyCardGroup';
import { ChartData } from './ChartRenderer';

interface ChartDataGroupProps {
  charts: Array<{
    id: string;
    chartData: ChartData;
  }>;
  tone?: keyof typeof import('../styles/Palette').Palette;
  footnotes?: FootNoteProps[];
}

const ChartDataGroup: React.FC<ChartDataGroupProps> = ({ charts, tone = 'tone1', footnotes }) => {
  if (!charts || charts.length === 0) {
    return null;
  }

  // Group charts into pairs for 2 charts per row
  const groupedCharts = [];
  for (let i = 0; i < charts.length; i += 2) {
    groupedCharts.push(charts.slice(i, i + 2));
  }

  return (
    <Box>
      {groupedCharts.map((group, groupIndex) => (
        <PropertyCardGroup
          key={`chart-group-${groupIndex}`}
          tone={tone}
          noSpacing={groupIndex > 0} // Add spacing between groups
          noTopPadding={groupIndex === 0}
        >
          {group.map((chart) => (
            <PropertyCard
              key={chart.id}
              tone={tone}
              title={chart.chartData.title}
              description={chart.chartData.description}
              noImageModal={true}
              chartData={chart.chartData}
              isHtmlDescription={true}
              footnotes={footnotes}
              forceExpanded
            />
          ))}
        </PropertyCardGroup>
      ))}
      {footnotes && <FootnoteRenderer footnotes={footnotes} tone={tone} />}
    </Box>
  );
};

export default ChartDataGroup;
